import { Phone, Mail } from "lucide-react";
import { COMPANY, CONTACT } from "../../lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0B1D3A] text-white border-t-2 border-[#C9A961]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-16">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <img
              src={COMPANY.logo}
              alt="Noble Power Solutions"
              className="h-52 lg:h-64 w-auto object-contain"
              style={{
                filter:
                  "drop-shadow(0 0 16px rgba(255,255,255,0.35)) drop-shadow(0 0 44px rgba(201,169,97,0.35))",
              }}
            />
            <p className="mt-5 text-white/65 text-sm leading-relaxed max-w-md">
              {COMPANY.description}
            </p>
            <p className="mt-6 font-display text-[#C9A961] italic text-base">
              &ldquo;{COMPANY.tagline}&rdquo;
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-display font-semibold text-white text-[13px] uppercase tracking-[0.22em] mb-5">
              Navigate
            </p>
            <ul className="space-y-2.5 text-sm">
              {[
                { href: "#about", label: "About" },
                { href: "#services", label: "Services" },
                { href: "#engines", label: "Engines" },
                { href: "#capabilities", label: "Aircrafts" },
                { href: "#team", label: "Team" },
                { href: "#contact", label: "Contact" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-white/70 hover:text-[#C9A961] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="font-display font-semibold text-white text-[13px] uppercase tracking-[0.22em] mb-5">
              Reach Us
            </p>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#C9A961] mt-1 flex-shrink-0" />
                <a
                  href={CONTACT.salesPhoneHref}
                  className="text-white/85 hover:text-[#C9A961]"
                >
                  {CONTACT.salesPhone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#C9A961] mt-1 flex-shrink-0" />
                <a
                  href={`mailto:${CONTACT.generalEmail}`}
                  className="text-white/80 hover:text-[#C9A961]"
                >
                  {CONTACT.generalEmail}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-white/55">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-[11px] uppercase tracking-[0.22em] text-white/45 font-mono">
            ASA-100 · FAA · EASA Documentation Ready
          </p>
        </div>
      </div>
    </footer>
  );
}
